import graphqlClient from "../../../apollo";

class MarcaProvider {

    findMarca(id) {
        return graphqlClient.query({
            query: require('./gql/marcaFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchMarcas() {
        return graphqlClient.query({
            query: require('./gql/marcaFetch.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateMarcas(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/marcaPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    getMarcaUpdateImpact(marcaId) {
        return graphqlClient.query({
            query: require('./gql/marcaUpdateImpact.graphql'),
            variables: { marcaId },
            fetchPolicy: "network-only"
        })
    }

    createMarca(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/marcaCreate.graphql'),
            variables: form
        })
    }

    updateMarca(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/marcaUpdate.graphql'),
            variables: form
        })
    }

    deleteMarca(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/marcaDelete.graphql'),
            variables: { id }
        })
    }

}

export default new MarcaProvider()


